import React, { useState } from 'react';
import { Dialog, Box, makeStyles } from '@material-ui/core';

import { Close } from '~/components/icons/Close';

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      display: 'flex',
      width: '360px',
      padding: 'var(--utilities-size-none, 0px)',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 'var(--utilities-size-none, 0px)',
      borderRadius: 'var(--utilities-border-radius-xl, 16px)',
      background: 'var(--background-surface-default, #FFF)',
      boxShadow: 'var(--shadows-modal)',
    },
  },
  titleSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-1-250, 20px) var(--utilities-size-1-500, 24px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
    background: 'var(--surface-default, #FFF)',
  },
  mainSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-none, 0px) var(--utilities-size-1-500, 24px) var(--utilities-size-1-500, 24px) var(--utilities-size-1-500, 24px)',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-500, 24px)',
    alignSelf: 'stretch',
    background: 'var(--surface-default, #FFF)',
  },
  title: {
    flex: '1 0 0',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  closeIcon: {
    width: 'var(--utilities-size-1-500)',
    height: 'var(--utilities-size-1-500)',
    cursor: 'pointer',
  },
  textSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-0-500, 8px) var(--utilities-size-0-500, 8px) var(--utilities-size-1-000, 16px)',
    alignItems: 'center',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    border: '1px solid var(--border-danger-weak, rgba(239, 68, 68, 0.20))',
    background: 'var(--surface-danger-tint, rgba(239, 68, 68, 0.10))',
  },
  buttonsSection: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
  },
  warningText: {
    flex: '1 0 0',
    color: 'var(--content-danger, #EF4444)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-sm, 14px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-sm-line, 20px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  cancelButton: {
    display: 'flex',
    minHeight: 'var(--utilities-size-2-500, 40px)',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-1-000, 16px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-0-500, 8px)',
    flex: '1 0 0',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    border: '1px solid var(--border-control-default, rgba(23, 28, 38, 0.20))',
    background: 'var(--surface-default, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
    '&:hover': {
      backgroundColor:
        'var(--surface-hover-tint-weak-hover, rgba(23, 28, 38, 0.10))',
      cursor: 'pointer',
    },
  },
  cancelText: {
    color: 'var(--content-primary, #2C313A)',
    textAlign: 'center',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
}));

const RestrictionUpdateDialog = ({ open, onClose, setDialogOpen }) => {
  const classes = useStyles();

  const [hoveredClose, setHoveredClose] = useState(null);

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <Box className={classes.titleSection}>
        <Box className={classes.title}>Access restriction</Box>
        <Box
          className={classes.closeIcon}
          onClick={handleClose}
          onMouseEnter={() => setHoveredClose(true)}
          onMouseLeave={() => setHoveredClose(null)}
        >
          <Close color={hoveredClose ? '#2C313A' : '#7c7e83'} />
        </Box>
      </Box>
      <Box className={classes.mainSection}>
        <Box className={classes.textSection}>
          <Box className={classes.warningText}>
            This action is not available for your own account.
          </Box>
        </Box>
        <Box className={classes.buttonsSection}>
          <Box className={classes.cancelButton} onClick={handleClose}>
            <Box className={classes.cancelText}>Cancel</Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default RestrictionUpdateDialog;
